import React from 'react';
import { components } from 'react-select';
import { Draggable } from 'react-beautiful-dnd';
import { Icon, Tooltip } from '@branchjs/neo-components';
import { useDraggableMultiValueService } from 'client/js/common/components/core/PureQueryBuilder/DraggableCompareBy/hooks';
import type { IndexedOption, MultiValueProps } from 'client/libraries/branch-neo-next/OrderedSelectDropdown/types';

const DraggableMultiValue = (props: MultiValueProps<IndexedOption>) => {
  const { css, innerProps, disabled } = useDraggableMultiValueService(props);

  const draggableElement = (
    <Draggable key={props.data.value} draggableId={props.data.value} index={props.data.index}>
      {(provided) => (
        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className={css.label}>
          <components.MultiValue {...props} innerProps={innerProps} />
        </div>
      )}
    </Draggable>
  );

  const title = (
    <div className={css.title}>
      <Icon className={css.icon} color="warning">
        warning
      </Icon>
      The maximum limit for the compare-by filter is four. Other selected compare-by filters will be disabled. Please reorder
      or delete some filters to view the results.
    </div>
  );

  if (!disabled) {
    return draggableElement;
  }

  return (
    <Tooltip id={`draggable-multi-value-tooltip-${props.data.value}`} title={title} placement="bottom-start">
      <div>{draggableElement}</div>
    </Tooltip>
  );
};

export default DraggableMultiValue;
